// ** Initial State
const initialState = {
    result_list: [],
    result_group: [],
    total: 0,
    sign: null,
    timestamp: null,
    endpoint: null,
    notification: null
}

const chatBotTicketGroup = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_BOT_TICKET_GROUP':
            return {
                ...state,
                result_group: action.data,
                total: action.total
            }
        default:
            return { ...state }
    }
}

export {
    chatBotTicketGroup
}